import React from "react";
import { object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { getTemplateName } from "../../utils";

import { FOLLOW_US_ICONS } from "../../../constants";
import { SvgIconHandler } from "../../atoms/SvgIconHandler";
import { WhatsApp } from "../../../arrow/components/Svgs/SocialIcons/whatsapp";

export const FollowUsIcons = ({ socialLinks, customIcons = {}, noIcon = true }) => {
  if (!Object.keys(socialLinks).length) return;

  // Get pageType from Redux store for template name
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], null);

  // Track social media icon clicks for dataLayer analytics
  const trackSocialClick = (e, icon, url) => {
    e.preventDefault();
    e.stopPropagation();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_footer_clicks",
      link_url: url,
      link_text: icon.label.toLowerCase(),
      link_category: "social-media",
      category: "footer",
      sub_category: icon.label.toLowerCase(),
      content_id: "NA",
      template_name: getTemplateName(pageType) || "footer-social",
      platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      eventCallback: function () {
        window.open(url, "_blank");
      },
    });
  };

  return FOLLOW_US_ICONS.map((icon) => {
    const { type, label, urlKey } = icon;
    const custom = customIcons[type] || {};
    const socialUrl = socialLinks[urlKey];

    if (!socialUrl) return null;
    if (
      (type === "follow-linkedin" || type === "follow-google") &&
        !custom.label
      ) {
        return null;
      }
    if ((type === "follow-facebook" || type === "follow-youtube") && custom.label) return null;
    return (
      <li className="follow-us-item" key={type}>
        <div onClick={(e) => trackSocialClick(e, icon, socialUrl)} style={{ display: "contents" }}>
          <a href={socialUrl} target="_blank" rel="nofollow noopener noreferrer" aria-label={label}>
            {type === "follow-whatsapp" && <i className="footerwhatsappicon"><WhatsApp /></i>}
            {type === "follow-instagram" && <i className="footerinstaicon" />}
            {type === "follow-google" && <i className="footergoogleicon" />}
            {type === "follow-facebook" && <i className="footerfbicon" />}
            {type === "follow-x" && <i className="footerxicon" />}
            {type === "follow-youtube" && <i className="footeryoutubeicon" />}
            {type === "follow-linkedin" && <i className="footerlinedinicon" />}
            {/* <SvgIconHandler type={type} width="28" height="28" /> */}
            {custom.svg}
            {custom.label && <span>{custom.label}</span>}
          </a>
        </div>
      </li>
    );
  });
};

FollowUsIcons.propTypes = {
  socialLinks: object,
};
